"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));
    this.$section = $section;

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
    $(document).on('click', '.ajax-cart #gift-wrapping-link', function (e) {
      e.preventDefault();
      const quantity = e.target.checked ? 1 : 0;
      Shopify.theme.jsAjaxCart.toggleGiftWrapping(quantity);
      return false;
    });
    $(document).on('submit', '.gc-msg-hidden', function (e) {
      e.preventDefault();
      const formData = new FormData(e.target)
      const message = formData.get('attributes[gift-card-message]')
      Shopify.theme.jsAjaxCart.toggleGiftMessage(message);
      return false;
    });

    if(window.location.hash === '#cart-open'){
      Shopify.theme.jsAjaxCart.showDrawer();
    }
  },
  initUpsellCarousel: function initUpsellCarousel(){
    const carousel = $('.upsell-products-container .slider-gallery')
    const alreadyRendered = $(carousel).hasClass('slick-initialized')
    const onlyOneSlide = $(carousel).data('products-available') === 1

    if(alreadyRendered || onlyOneSlide) return;

    $(carousel).slick({
      slidesToShow: 1.5,
      infinite: false,
      slidesToScroll: 1,
      swipeToSlide: true,
      draggable: true,
      arrows: true,
      rows: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 468,
          settings: {
            slidesToShow: 1.5
          }
        }
      ]
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html, body').css('overflow', 'hidden')
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html, body').css('overflow', '')
  },
  removeFromCart: function removeFromCart(lineID, callback) {
    var item = Shopify.theme.jsAjaxCart.$section.find("[data-line-item=\"".concat(lineID, "\"]"));
    var productId = item.attr('data-cart-item').split(':')[0];
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        var giftWrappingLink = $('.ajax-cart #gift-wrapping-link');
        var giftWrappingProductId = giftWrappingLink.attr('data-productid');
        if(productId === giftWrappingProductId) {
          $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: 'attributes[gift-wrapping]=""',
            success: function success(_product) {
              Shopify.theme.jsAjaxCart.updateView();
            }
          });
        }

        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView.load(Shopify.routes.cart_url, // template name
    'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
          options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content); // Converting the currencies

      if (Currency.show_multiple_currencies) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
      Shopify.theme.jsAjaxCart.initUpsellCarousel()
    }).fail(function () {// some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView.load(Shopify.routes.cart_url, // template name
    'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
          options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);
    }).fail(function () {// some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('.text, .icon, .atc-text-wrapper, .atc-text, .custom_pdp_price, .sold-out-text').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('.text').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
      }
    });
  },
  toggleGiftWrapping: function toggleGiftWrapping(quantity = 1) {
    var giftWrappingLink = $('.ajax-cart #gift-wrapping-link');
    var giftWrappingProductId = giftWrappingLink.attr('data-productid');
    const attributes = quantity === 0 ? 'attributes[gift-wrapping]':  'attributes[gift-wrapping]=true'
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: `updates[${giftWrappingProductId}]=${quantity}&${attributes}`,
      success: function success(_product) {
        Shopify.theme.jsAjaxCart.updateView();
      }
    });
  },
  toggleGiftMessage: function toggleGiftMessage(message = "") {
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: `attributes[gift-card-message]=${message}`
    });
  },
  updateView: function updateView() {
    Shopify.theme.asyncView.load(Shopify.routes.cart_url, // template name
    'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
          options = _ref3.options;


        var itemList = $(html.content).find('.ajax-cart__list');
        var cartGift = $(html.content).find('.cart-gift-wrapping-message.ajax-cart__row-description');
        var cartCount = $(html.content).find('.ajax-cart__count');
        var cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
        var freeShipMessage = $(html.content).find('.free-ship-message');
        var progressBar = $(html.content).find('.cart-progress-bar');
        var $htmlContent = $(html.content);
        var upsellContainer = $htmlContent.filter(function() {
          return $(this).hasClass('upsell-container');
        });
      if (options.item_count > 0) {
        $('.ajax-cart__list').replaceWith(itemList);
        $('.cart-gift-wrapping-message.ajax-cart__row-description').replaceWith(cartGift);
        $('.ajax-cart__count').replaceWith(cartCount);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.free-ship-message').replaceWith(freeShipMessage);
        $('.cart-progress-bar').replaceWith(progressBar);
        $('.upsell-container').replaceWith(upsellContainer);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        // $('.ajax-cart__form').removeClass('is-hidden');
        $('.ajax-cart__footer').removeClass('is-hidden');
        // $('.upsell-container').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('.ajax-cart__list').replaceWith(itemList);
        $('.cart-gift-wrapping-message.ajax-cart__row-description').replaceWith(cartGift);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.free-ship-message').replaceWith(freeShipMessage);
        $('.cart-progress-bar').replaceWith(progressBar);
        $('.ajax-cart__count').replaceWith(cartCount);
        $('.upsell-container').replaceWith(upsellContainer);
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        // $('.ajax-cart__form').addClass('is-hidden');
        $('.ajax-cart__footer').addClass('is-hidden');
        // $('.upsell-container').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');

      }

      Shopify.theme.jsAjaxCart.initUpsellCarousel()

      if (Currency.show_multiple_currencies) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }

    }).fail(function () {// some error handling
    });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
};
